export const HeaderNames = {
  IDEMPOTENCY_KEY: 'Idempotency-Key',
  CONTENT_TYPE: 'Content-Type'
}
